import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { ref } from 'vue'
import Simplemde from '../atoms_molecules/Simplemde.vue'
import UserQuestionFormView from './UserQuestionFormView.vue'
import { checkMobile } from '../../utils/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserQuestionDialog',
  props: {
    courseId: { default: '' },
    lessonId: { default: '' }
  },
  setup(__props: any) {

const props = __props

const dialog = ref(false)
const mobile = checkMobile()

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialog).value = $event)),
    "max-width": "950",
    persistent: ""
  }, {
    activator: _withCtx(({ props }) => [
      (_unref(mobile))
        ? (_openBlock(), _createElementBlock("button", _mergeProps({
            key: 0,
            type: "button",
            class: "btn rounded-pill bg-dark text-white"
          }, props), " 質問を作成する ", 16 /* FULL_PROPS */))
        : (_openBlock(), _createBlock(_component_v_btn, _mergeProps({
            key: 1,
            icon: "mdi-plus",
            size: "small",
            color: "teal"
          }, props), null, 16 /* FULL_PROPS */))
    ]),
    default: _withCtx(() => [
      _createVNode(UserQuestionFormView, {
        modelValue: dialog.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
        courseId: __props.courseId,
        lessonId: __props.lessonId
      }, null, 8 /* PROPS */, ["modelValue", "courseId", "lessonId"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}
}

})